package com.milta.core.localization.translations.es

import com.milta.core.localization.SpreadsheetImportStrings

internal val SpreadsheetImport = SpreadsheetImportStrings(
    importFileTitle = "Importar un archivo",
    analysingTitle = "Analizando el archivo…",
    analysingSubtitle = "Estamos identificando las columnas y detectando las entregas presentes en la hoja.",
    fileSentSuffix = "enviado hace un momento",
    structuredFormatBannerTitle = "Formato reconocido.",
    structuredFormatBannerMessage = "Las columnas se asignaron automáticamente, no se necesita ninguna corrección.",
    columnsInterpretedBannerTitle = "Columnas interpretadas automáticamente.",
    columnsInterpretedBannerMessage = "Revise las entregas señaladas antes de agregarlas.",
    completePillLabel = "Todo está completo",
    invalidFileTitle = "Archivo no admitido.",
    invalidFileMessage = "Importe un archivo Excel (.xlsx) o CSV (.csv) válido.",
    chooseAnotherFileButton = "Elegir otro archivo",
    extractionFailedTitle = "No se puede leer este archivo.",
    extractionFailedMessage = "La hoja parece vacía o su estructura no fue reconocida — revise su contenido o introduzca las entregas manualmente.",
    retryWithNewFileButton = "Reintentar con otro archivo",
    serviceUnavailableTitle = "Servicio de análisis temporalmente no disponible.",
    serviceUnavailableMessage = "Vuelva a intentarlo en unos instantes, o complete esta entrega manualmente mientras tanto.",
)
